import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cedb1262"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "login-outer"
};
const _hoisted_2 = {
  class: "flex-box justify-content-center margin-bottom-10"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "page-title"
}, "JoinMC", -1));
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
const _hoisted_6 = {
  key: 0
};
const _hoisted_7 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_image = _resolveComponent("van-image");
  const _component_phoneComp = _resolveComponent("phoneComp");
  const _component_accountComp = _resolveComponent("accountComp");
  const _component_CustomActionSheet = _resolveComponent("CustomActionSheet");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_van_image, {
    width: "60",
    height: "60",
    src: require('@/assets/images/logo.png')
  }, null, 8, ["src"])]), _hoisted_3, $data.isWeChat && _ctx.$route.query.isFromRocket != 1 ? (_openBlock(), _createElementBlock("div", _hoisted_4)) : (_openBlock(), _createElementBlock("div", _hoisted_5, [$data.isPhoneLogin ? (_openBlock(), _createElementBlock("section", _hoisted_6, [_createVNode(_component_phoneComp, {
    onNoTeam: $options.noTeamHandler,
    onChangeLoginType: _cache[0] || (_cache[0] = $event => $data.isPhoneLogin = false),
    onSuccess: $options.loginSuccessCallback,
    wechat_oa_token: $data.wechat_oa_token
  }, null, 8, ["onNoTeam", "onSuccess", "wechat_oa_token"])])) : (_openBlock(), _createElementBlock("section", _hoisted_7, [_createVNode(_component_accountComp, {
    onNoTeam: $options.noTeamHandler,
    onChangeLoginType: _cache[1] || (_cache[1] = $event => $data.isPhoneLogin = true),
    onSuccess: $options.loginSuccessCallback
  }, null, 8, ["onNoTeam", "onSuccess"])]))])), _createVNode(_component_CustomActionSheet, {
    title: "切换登录方式",
    ref: "actionSheetRef",
    onSelect: $options.handleActionSelect,
    actions: $data.actionArray
  }, null, 8, ["onSelect", "actions"])]);
}